import type { GetOversightActivityCountQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightActivityCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

export const useGetOversightActivityCount = createQueryHook<
  Record<string, never>,
  number,
  GetOversightActivityCountQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.assessment.oversightActivityCount.queryOptions(),
  // Pass the count straight through (not `data ?? 0`): the createQueryHook
  // factory already surfaces undefined while loading, so a genuine 0 must
  // stay 0 rather than be masked by a coerced fallback.
  mapTrpcDataToGraphQL: (data) => ({
    assessment_activity_aggregate: {
      aggregate: {
        count: data,
      },
    },
  }),
  graphqlDocument: GetOversightActivityCountDocument,
});
